export default {"src":"/login-app/[GIT_HASH]/_next/static/media/dagster_primary.7b92f477.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};